import React from 'react';

import useBurnCenters from 'hooks/useBurnCenters';

import Select from 'components/elements/FormInput/select/Select';

interface BurnCenterFilterProps {
  isMulti?: boolean;
  onChange?: (_: string | number | Array<string | number> | null) => void;
  value?: string | number | Array<string | number> | null;
}

const BurnCenterFilter: React.FC<BurnCenterFilterProps> = ({ isMulti, onChange, value }) => {
  const { burnCenterOptions } = useBurnCenters();

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={`Burncenter${isMulti ? 's' : ''}`}
      options={burnCenterOptions}
      isMulti={isMulti}
      isClearable
    />
  );
};

export default BurnCenterFilter;
